import React from "react";
import {
    CityFilter,
    MultiSelectFilter,
    RadiusFilter,
    ResetFiltersButton,
    SingleSelectFilter,
} from "components/ListPage/filters";
import { useInlineAdFilters } from "./useInlineAdFilters";

const FiltersBar: React.FC = () => {
    const { labels, options, selected, state, handlers } = useInlineAdFilters();
    const {
        category,
        subcategory,
        frequency,
        posted,
        city,
        radius,
        radiusAll,
        radiusValue,
        selectedCount,
        reset,
    } = labels;
    const {
        categories,
        subcategories,
        frequencies,
        postedPeriodClear,
        postedPeriods,
        cities,
    } = options;
    const {
        categories: selectedCategories,
        subcategories: selectedSubcategories,
        frequencies: selectedFrequencies,
        postedPeriod,
        radius: selectedRadius,
        city: selectedCity,
    } = selected;
    const { canUseRadius, hasInlineAdFilters } = state;
    const {
        handleCategoryChange,
        handleSubcategoryChange,
        handleFrequencyChange,
        handlePostedPeriodChange,
        handleRadiusChange,
        handleCityInputChange,
        handleCitySelect,
        handleReset,
    } = handlers;

    return (
        <div className="grid w-full grid-cols-1 gap-x-3 gap-y-3 sm:grid-cols-3 xl:grid-cols-6">
            <MultiSelectFilter
                label={category}
                options={categories}
                selectedCountLabel={selectedCount}
                selectedValues={selectedCategories}
                onChange={handleCategoryChange}
            />

            <MultiSelectFilter
                disabled={subcategories.length === 0}
                label={subcategory}
                options={subcategories}
                selectedCountLabel={selectedCount}
                selectedValues={selectedSubcategories}
                onChange={handleSubcategoryChange}
            />

            <MultiSelectFilter
                label={frequency}
                options={frequencies}
                selectedCountLabel={selectedCount}
                selectedValues={selectedFrequencies}
                onChange={handleFrequencyChange}
            />

            <SingleSelectFilter
                clearOption={postedPeriodClear}
                label={posted}
                selectedValue={postedPeriod}
                options={postedPeriods}
                onChange={handlePostedPeriodChange}
            />

            <CityFilter
                label={city}
                inputValue={selectedCity}
                options={cities}
                onInputChange={handleCityInputChange}
                onSelect={handleCitySelect}
            />

            <RadiusFilter
                disabled={!canUseRadius}
                label={radius}
                radiusAllLabel={radiusAll}
                radiusLabel={radiusValue}
                selectedValue={selectedRadius}
                onChange={handleRadiusChange}
            />

            {hasInlineAdFilters ? (
                <div className="col-span-full justify-self-end">
                    <ResetFiltersButton label={reset} onReset={handleReset} />
                </div>
            ) : null}
        </div>
    );
};

export default FiltersBar;
